import React from "react";
import "./GDriveConnectButton.css";

interface IGDriveConnectButtonProps{
    onClick: ()=>void;
}

export const GDriveConnectButton = ({onClick}: IGDriveConnectButtonProps)=>{
    return <div className="GDriveConnectButton">
        <div className="GDriveConnectButton_text">
            Connection to GDrive service is required to watch this content.
        </div>
        <div className="GDriveConnectButton_logo"></div>
        <div className="button GDriveConnectButton_button" onClick={onClick}>Connect GDrive</div>
    </div>
    
}